import { render, staticRenderFns } from "./Modelli.vue?vue&type=template&id=389d8333&"
import script from "./Modelli.vue?vue&type=script&lang=js&"
export * from "./Modelli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports